import { render, staticRenderFns } from "./CoachManagerAttributionsTreated.vue?vue&type=template&id=d863c466"
import script from "./CoachManagerAttributionsTreated.vue?vue&type=script&lang=js"
export * from "./CoachManagerAttributionsTreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports